import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** First-party, cookieless page-view tracking (skips admin routes). */
const AnalyticsTracker = () => {
  const { pathname } = useLocation();
  const lastPath = useRef(null);
  const firstHit = useRef(true);

  useEffect(() => {
    if (pathname.startsWith('/admin') || pathname === lastPath.current) return;
    lastPath.current = pathname;
    const referrer = firstHit.current ? document.referrer || '' : '';
    firstHit.current = false;
    fetch(`${API}/pv`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: pathname, referrer }),
      keepalive: true,
    }).catch(() => {});
  }, [pathname]);

  return null;
};

export default AnalyticsTracker;
